import { useTranslation } from 'react-i18next';
import { TableCell } from '@mui/material';
import { formatDateTime } from '@utils/date-helpers';
import { useTopUpOrderDialog } from '@utils/dialogs-hooks';
import { findOperationTypeLabel } from '@utils/statuses';

export function BalanceOperationDate({ row }) {
  return <p className="secondary-text">{formatDateTime(row.created_at)}</p>;
}

export function BalanceOperationType({ row }) {
  const { t } = useTranslation();
  return <p>{t(findOperationTypeLabel(row.type))}</p>;
}

export default function BalanceOperationCell({ row }) {
  const { openTopUpOrderDialog } = useTopUpOrderDialog();
  return (
    <TableCell>
      <div className="bankOperationCell">
        {row.type === 0 ? (
          <button
            className="dashed-btn"
            onClick={() => openTopUpOrderDialog(row.id_from)}
          >
            <BalanceOperationType row={row} />
          </button>
        ) : (
          <BalanceOperationType row={row} />
        )}
        <BalanceOperationDate row={row} />
      </div>
    </TableCell>
  );
}
